import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import RegionLabel from 'components/RegionLabel/RegionLabel';

import { ReactComponent as Logo } from 'assets/icons/logoMonochrome.svg';

import packageJson from '../../../package.json';
import styles from './Footer.module.scss';
import FeedbackSection from './components/FeedbackSection/FeedbackSection';
import { FOOTER_LINKS_CONFIG, FOOTER_SOCIAL_CONFIG } from './footerConfig';

const LINK_PROPS = {
  target: '_blank',
  rel: 'noreferrer'
};

const Footer = () => {
  const year = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer>
      <FeedbackSection />
      <section className={styles.container}>
        <div className={styles.logo}>
          <div className={styles.logoInnerContainer}>
            <Logo />
            <div>{packageJson?.version}</div>
          </div>
        </div>
        <div className={styles.linksWrapper}>
          <div className={styles.links}>
            {FOOTER_LINKS_CONFIG.map(({ name, href }, index) => (
              <div key={index} className={styles.column}>
                <Link {...LINK_PROPS} className={styles.link} to={href}>
                  {t(name)}
                </Link>
              </div>
            ))}
          </div>
          <div className={styles.socialLinks}>
            {FOOTER_SOCIAL_CONFIG.map(({ icon, href }, index) => (
              <div key={index} className={styles.column}>
                <Link {...LINK_PROPS} className={styles.socialLink} to={href}>
                  <div className={styles.iconWrapper}>{icon}</div>
                </Link>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.divider} />
        <div className={styles.copyright}>
          {t('common.label.copyright')} © {year} Joblio (<RegionLabel />)
        </div>
      </section>
    </footer>
  );
};

export default Footer;
